export const heroImage =
  "https://readdy.ai/api/search-image?query=Wide%20view%20of%20a%20realistic%20American%20community%20college%20campus%20on%20a%20clear%20sunny%20day%2C%20red%20brick%20and%20beige%20academic%20buildings%2C%20neatly%20maintained%20green%20lawn%2C%20wide%20concrete%20walkway%2C%20leafy%20trees%2C%20bright%20blue%20sky%2C%20a%20few%20casually%20dressed%20students%20walking%20naturally%20in%20the%20distance%2C%20natural%20daylight%2C%20documentary%20photography%20style%2C%20calm%20and%20welcoming%20atmosphere%2C%20no%20text&width=1200&height=800&seq=usa-campus-hero-01&orientation=landscape";

export const operatorImage =
  "https://readdy.ai/api/search-image?query=Peaceful%20study%20desk%20beside%20a%20large%20window%20overlooking%20a%20sunny%20American%20community%20college%20campus%2C%20an%20open%20laptop%2C%20a%20paper%20notebook%2C%20a%20pen%20and%20a%20cup%20of%20coffee%20arranged%20on%20a%20light%20oak%20table%2C%20green%20trees%20and%20red%20brick%20academic%20buildings%20visible%20through%20the%20glass%2C%20soft%20morning%20daylight%2C%20calm%20academic%20atmosphere%2C%20editorial%20interior%20photography%2C%20muted%20natural%20tones%2C%20no%20people%2C%20no%20text&width=900&height=1100&seq=usa-study-desk-window-09&orientation=portrait&nocache=true";

export type NavItem = {
  label: string;
  to: string;
  // Google フォームなど、サイト外のページを新しいタブで開く項目
  external?: boolean;
  free?: boolean;
};

export const navItems: NavItem[] = [
  { label: "ホーム", to: "/" },
  { label: "無料で学ぶ", to: "/learn" },
  { label: "有料ガイド", to: "/guides" },
  { label: "留学ブログ", to: "/blog" },
  { label: "運営者について", to: "/about" },
  { label: "お問い合わせ", to: "/#contact", external: true, free: true },
];

export const learnCards = [
  {
    id: "community-college",
    to: "/learn/community-college",
    icon: "ri-file-list-3-line",
    category: "コミカレの始め方",
    title: "コミカレの始め方",
    description:
      "コミュニティカレッジの仕組みから、出願からI-20発行までの流れ、必要書類までをまとめています。メリットと注意点、留学前に確認しておきたい項目も整理しました。",
    badge: "無料",
  },
  {
    id: "english-test",
    to: "/learn/english-test",
    icon: "ri-translate-2",
    category: "英語力証明試験",
    title: "英語力証明試験（TOEFL・DET・IELTS）",
    description:
      "出願で使われるTOEFL iBT・Duolingo English Test・IELTS Academicの目的と仕組み、受験方法を整理しています。2026年1月からのTOEFLの1〜6スケールや、学校ごとに基準が異なる点、TSIA2との違いも解説します。",
    badge: "無料",
  },
  {
    id: "f1-visa",
    to: "/learn/f1-visa",
    icon: "ri-passport-line",
    category: "F-1ビザ申請",
    title: "F-1ビザ申請",
    description:
      "F-1ビザの基本と、I-20・SEVIS・DS-160の役割を整理しています。申請から面接までの流れ、必要書類、費用の考え方までをまとめました。",
    badge: "無料",
  },
  {
    id: "tsi",
    to: "/learn/tsi",
    icon: "ri-draft-line",
    category: "TSI（TSIA2）対策",
    title: "TSI（TSIA2）対策",
    description:
      "TSIA2が「合否を決める試験ではない」という位置づけから、ELARと数学の内容、基準点の考え方までを解説します。基準に届かなかった場合の対応と、公式学習資料の確認方法も載せています。",
    badge: "無料",
  },
  {
    id: "transfer",
    to: "/learn/transfer",
    icon: "ri-line-chart-line",
    category: "4年制大学への編入",
    title: "4年制大学への編入",
    description:
      "コミカレから4年制大学へ編入する仕組みと、GPA・単位数・前提科目の考え方をまとめています。準備の流れと、編入が保証されないという前提も整理しました。",
    badge: "無料",
  },
  {
    id: "cost-life",
    to: "/learn/cost-life",
    icon: "ri-home-5-line",
    category: "費用と学生生活",
    title: "費用と学生生活",
    description:
      "留学費用の内訳（学費・住居・保険・教科書など）と、費用を抑える考え方を整理しています。寮生活や授業、現地での生活で気をつけたい点もまとめました。",
    badge: "無料",
  },
];

export const transferSteps = [
  {
    id: "step-1",
    step: "01",
    title: "コミカレに出願",
    description:
      "高校の成績証明書や英語スコア、財政証明を用意し、エージェントを通さずに自分で出願します。",
  },
  {
    id: "step-2",
    step: "02",
    title: "F-1ビザを取得",
    description:
      "I-20を受け取り、SEVIS手数料の支払いとDS-160の入力、面接を経て学生ビザを取得します。",
  },
  {
    id: "step-3",
    step: "03",
    title: "TSIA2で授業配置を確認",
    description:
      "テキサス州の公立校ではTSIA2が案内されます。結果に応じて、履修できる授業が決まります。",
  },
  {
    id: "step-4",
    step: "04",
    title: "GPAと単位を積み、編入申請",
    description:
      "編入に必要な単位数とGPA、専攻の前提科目を意識しながら履修し、志望校へ出願します。",
  },
];